import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StayCurrentLandscapeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stay_current_landscape"}/>
}
